app.service('goBack',function( console, localStorage, loading, front){
	function go(){
		console.log('POWRÓT DO POPRZEDNIEJ STRONY');
		var url='/';
		if (!localStorage.empty('refpage')){
			url = check(localStorage.getItem('refpage'));
		}
		loading.redirect(url);
	}

	function check(tmpUrl){
		tmpUrl = "" +tmpUrl;
		if(tmpUrl.indexOf("<")>-1){
			tmpUrl = tmpUrl.substr(0, tmpUrl.indexOf("<"));
		}
		return tmpUrl;
	}

	function setRefPage(){
		if(front.group() !== 'order' && front.group() !== 'account'){
			localStorage.setItem('refpage', check(self.location.href));
		}
	}

	return {
		setRefPage:setRefPage,
		go:go
	};
});
